import { render } from "./AssignStatusModal.vue?vue&type=template&id=0d2e3b8a"
import script from "./AssignStatusModal.vue?vue&type=script&lang=js"
export * from "./AssignStatusModal.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__